// extracted by mini-css-extract-plugin
module.exports = {"nav":"admin-nav_nav__6UBgP","nav__list":"admin-nav_nav__list__3A4eY"};